import { cdnUrl } from '../../config';

const nyBoxVariants = [
  `${cdnUrl}/BOX/bags/ny_bag_1.png`,
  `${cdnUrl}/BOX/bags/ny_bag_2.png`,
  `${cdnUrl}/BOX/bags/ny_bag_3.png`,
  `${cdnUrl}/BOX/bags/ny_bag_4.png`,
  `${cdnUrl}/BOX/bags/ny_bag_5.png`,
  `${cdnUrl}/BOX/bags/ny_bag_6.png`,
  `${cdnUrl}/BOX/bags/ny_bag_7.png`,
  `${cdnUrl}/BOX/bags/ny_bag_8.png`,
  `${cdnUrl}/BOX/bags/ny_bag_9.png`,
  `${cdnUrl}/BOX/bags/ny_bag_10.png`,
  `${cdnUrl}/BOX/bags/ny_bag_11.png`,
  `${cdnUrl}/BOX/bags/ny_bag_12.png`,
  //
  `${cdnUrl}/BOX/balls/ny_ball_1.png`,
  `${cdnUrl}/BOX/balls/ny_ball_2.png`,
  `${cdnUrl}/BOX/balls/ny_ball_3.png`,
  `${cdnUrl}/BOX/balls/ny_ball_4.png`,
  `${cdnUrl}/BOX/balls/ny_ball_5.png`,
  `${cdnUrl}/BOX/balls/ny_ball_7.png`,
  `${cdnUrl}/BOX/balls/ny_ball_8.png`,
  `${cdnUrl}/BOX/balls/ny_ball_9.png`,
  `${cdnUrl}/BOX/balls/ny_ball_10.png`,
  //
  `${cdnUrl}/BOX/socks/ny_sock_1.png`,
  `${cdnUrl}/BOX/socks/ny_sock_2.png`,
  `${cdnUrl}/BOX/socks/ny_sock_3.png`,
  `${cdnUrl}/BOX/socks/ny_sock_4.png`,
  `${cdnUrl}/BOX/socks/ny_sock_5.png`,
  `${cdnUrl}/BOX/socks/ny_sock_6.png`,
  `${cdnUrl}/BOX/socks/ny_sock_7.png`,
];

const getBoxVariants = (): string[] => {
  const boxes = new Array(25).fill('').map((_, index) => `${cdnUrl}/images/boxes/${index + 1}.png`);
  const boxes2 = new Array(8).fill('').map((_, index) => `${cdnUrl}/BOX/gift-${index + 1}.png`);

  return [...boxes2, ...boxes, ...nyBoxVariants];
};

export const boxVariants = getBoxVariants();
